<template>
    <div>
        <TopHeaderTwo />
        <NavbarOneAboutUs />
        <MainBanner />
        <Time />
        <AboutUs />

        <OurCoreService 
            :subTitle="$t('aboutPage.section.subTitle')" 
            :heading="$t('aboutPage.section.heading')" 
        />

        <WhatsYouExpect />
        <OurStepAndProcess />
        <Counter class="three-counter-area" />
        <TeamLeadership />
        <CategoriesOfLoan />
        <FrequentlyQuestion />
        <ContactWithUs />
        <Review />
        <Join />
        <Blog class="two-blog-area" />
        <Subscribe />
        <Footer />
    </div>
</template>

<script>
import NavbarOneAboutUs from '../Layouts/NavbarOneAboutUs'
import MainBanner from '../HomeAboutUs/MainBanner'
import Time from '../HomeAboutUs/Time'
import AboutUs from '../HomeAboutUs/AboutUs'
import WhatsYouExpect from '../HomeAboutUs/WhatsYouExpect'
import OurCoreService from '../Common/OurCoreServiceAboutUs'
import OurCoreServiceMovility from '../Common/OurCoreServiceAboutUsMovility'
import OurStepAndProcess from '../HomeAboutUs/OurStepAndProcess'
import Counter from '../Common/Counter'
import TeamLeadership from '../HomeAboutUs/TeamLeadership'
import CategoriesOfLoan from '../Common/CategoriesOfLoan'
import FrequentlyQuestion from '../HomeAboutUs/FrequentlyQuestion'
import ContactWithUs from '../HomeAboutUs/ContactWithUs'
import Review from '../HomeAboutUs/Review'
import Join from '../HomeAboutUs/Join'
import Blog from '../Common/Blog'
import Subscribe from '../Common/Subscribe'
import Footer from '../Layouts/Footer'

export default {
    name: 'HomePageThree',
    components: {
        NavbarOneAboutUs,
        MainBanner,
        //Time,
        //AboutUs,
        OurCoreService,
        //OurStepAndProcess,
        //Counter,
        //TeamLeadership,
        //CategoriesOfLoan,
        //FrequentlyQuestion,
        //ContactWithUs,
        //Review,
        //Join,
        //Blog,
        //Subscribe,
        Footer,
    }
}
</script>